// eslint-disable-next-line
export default new (class NavbarModel {
  // static API_URL = process.env.REACT_APP_API_URL;

  async get(data) {
    const model = {};

    model.id = data.id || 0;
    model.menu = data.Menu || "";
    model.link = data.Link?.href || "";
    model.name_th = data.Link?.label_TH || "";
    model.name_en = data.Link?.label_EN || "";
    model.subMenu = data.subMenu || [];
    model.isOpen = false;
    model.order = data.order || "";

    return model;
  }
})();
